var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Object")])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_vm._v("Association")])])])
}]

export { render, staticRenderFns }